var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMymodules(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42857 9.85714H1.57143C1.41988 9.85714 1.27453 9.91735 1.16737 10.0245C1.0602 10.1317 1 10.277 1 10.4286V15.2857C1 15.4373 1.0602 15.5826 1.16737 15.6898C1.27453 15.7969 1.41988 15.8571 1.57143 15.8571H6.42857C6.58012 15.8571 6.72547 15.7969 6.83263 15.6898C6.9398 15.5826 7 15.4373 7 15.2857V10.4286C7 10.277 6.9398 10.1317 6.83263 10.0245C6.72547 9.91735 6.58012 9.85714 6.42857 9.85714ZM15.2857 9.85714H10.4286C10.277 9.85714 10.1317 9.91735 10.0245 10.0245C9.91735 10.1317 9.85714 10.277 9.85714 10.4286V15.2857C9.85714 15.4373 9.91735 15.5826 10.0245 15.6898C10.1317 15.7969 10.277 15.8571 10.4286 15.8571H15.2857C15.4373 15.8571 15.5826 15.7969 15.6898 15.6898C15.7969 15.5826 15.8571 15.4373 15.8571 15.2857V10.4286C15.8571 10.277 15.7969 10.1317 15.6898 10.0245C15.5826 9.91735 15.4373 9.85714 15.2857 9.85714ZM10.8629 1H6.00571C5.85416 1 5.70882 1.0602 5.60165 1.16737C5.49449 1.27453 5.43429 1.41988 5.43429 1.57143V6.42857C5.43429 6.58012 5.49449 6.72547 5.60165 6.83263C5.70882 6.9398 5.85416 7 6.00571 7H10.8629C11.0144 7 11.1598 6.9398 11.2669 6.83263C11.3741 6.72547 11.4343 6.58012 11.4343 6.42857V4V1.57143C11.4343 1.41988 11.3741 1.27453 11.2669 1.16737C11.1598 1.0602 11.0144 1 10.8629 1Z",
    stroke: "#363432",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 5,
    height: 5,
    fill: "#363432"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10,
    width: 5,
    height: 5,
    fill: "#363432"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 5,
    height: 5,
    fill: "#363432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMymodules);
export default __webpack_public_path__ + "static/media/mymodules.b0824ed95191cc123d0f3258dcfb2b09.svg";
export { ForwardRef as ReactComponent };